import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';
import FooterAR from '../Layout/FooterAR'
import HeaderAR from '../Layout/HeaderAR';
import HomeBody from './HomeBody';
import HomeBodyAR from './HomeBodyAR';
import Slider from './Slider/Slider';

const HomeAR = (props) => {

  useEffect(() => {
    document.querySelector('html').lang = 'ar';
  },[])
  return (
    <>
       <HeaderAR />
       {/* <Slider />
      <HomeBodyAR /> */}
      
      <div>
      <Outlet />
      </div>
       <FooterAR />
    </>
  )
}

export default HomeAR